module.exports = __webpack_public_path__ + "files/dc7b7052df5ca6a318a5853041d7d0f2.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/Lato-regular.eot
 ** module id = 394
 ** module chunks = 0
 **/